import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { GeneralConfigType, InteractionType, KeyValues5, KeyValueSet, LocalService, PageKey, TriggeredEvent } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';
import { WhitelistConfigComponent } from '../../popups/whitelist-config/whitelist-config.component';

@Component({
  selector: 'app-whitelists',
  templateUrl: './whitelists.component.html',
  styleUrls: ['./whitelists.component.scss']
})
export class WhitelistsComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["whitelist"];
  items: KeyValues5[]; statuses: KeyValueSet[]; ctryCode = ''; maxBodyHeight = 0;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private router: Router, private languageManagementService: LanguageManagementService, private profileManagementService: ProfileManagementService, private modalService: NgbModal, private configurationManagementService: ConfigurationManagementService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.ctryCode = this.localService.selected.countryCode;
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.configurationManagementService.ensurePageActions(PageKey.Whitelists);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.onLoad();
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight(40);
    this.cdr.detectChanges();
  }

  onLoad() {
    this.onGetConfiguration();
    this.onGetWhiteList();
  }

  onGetConfiguration() {
    this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.WhiteListStatus).subscribe(result => {
      this.statuses = result;
    });
  }

  onChangeAsCountry() {
    if (this.localService && this.localService.selected && this.localService.selected.countryCode) {
      const ctryCode = this.localService.selected.countryCode == this.localService.asCtryCode ? this.localService.asCtryCode : (this.localService.selected.countryCode + '-' + this.localService.asCtryCode);

      this.router.navigate([['/whitelist', ctryCode, this.localService.selected.user, InteractionType.Bill_PnixSoft].join('/')]);
    }
  }

  onGetWhiteList() {
    this.profileManagementService.getWhiteLists(this.localService.getLoginAsCountryCode()).subscribe(result => {
      this.items = result;
    });
  }

  onAddWhitelist(id = '') {
    const modalRef = this.modalService.open(WhitelistConfigComponent);
    modalRef.componentInstance.id = id;
    modalRef.componentInstance.ctryCode = this.ctryCode;
    if (id != '') {
      modalRef.componentInstance.statuses = this.statuses;
    }
    modalRef.result.then((result) => {
      if (result.event == TriggeredEvent.Ok) {
        if (id != '') {
          this.items.find(x => x.key == id).v4 = result.data;
        }
      }
    });
  }

  getName(key) {
    return this.statuses.find(x => x.key == key).value;
  }
}
